import React from 'react';
import { Link } from 'react-router-dom';
import './TaskGroups.css';

const TaskGroups = () => {
  return (
    <div className="taskgroups-page">
      <div className="container">
        <h1 className="page-title">Task Groups</h1>
        <p className="page-subtitle">Specialized working groups advancing different aspects of solution-focused approaches across Europe</p>
        
        <div className="taskgroups-grid">
          <Link to="/taskgroups/executive" className="taskgroup-card">
            <div className="card-icon">👥</div>
            <h3>Executive Task Group</h3>
            <p>Provides strategic leadership and governance for EBTA, making key decisions about the organization's direction and policies.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/international-cooperation" className="taskgroup-card">
            <div className="card-icon">🌍</div>
            <h3>International Cooperation Task Group</h3>
            <p>Facilitates collaboration between EBTA and international organizations, fostering global connections in solution-focused practice.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/research" className="taskgroup-card">
            <div className="card-icon">🔬</div>
            <h3>Research Task Group</h3>
            <p>Supporting, promoting and disseminating research activities related to the Solution Focused approach through publications, grants, and guidance.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/theory" className="taskgroup-card">
            <div className="card-icon">📚</div>
            <h3>Theory Task Group</h3>
            <p>Collecting, discussing, creating, and publishing solution-focused practice and theory related ideas for the community.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/psychotherapy" className="taskgroup-card">
            <div className="card-icon">🏥</div>
            <h3>Psychotherapy Task Group</h3>
            <p>Working towards European recognition of the Solution Focused approach by the European Association for Psychotherapy.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/conference" className="taskgroup-card">
            <div className="card-icon">🏛️</div>
            <h3>Conference Task Group</h3>
            <p>Organizing annual EBTA conferences and managing the scholarship program for worldwide participants.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/advisory" className="taskgroup-card">
            <div className="card-icon">💡</div>
            <h3>Advisory Task Group</h3>
            <p>Promoting ethical practices within EBTA through guidance, mediation, and maintaining professional standards.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/pr" className="taskgroup-card">
            <div className="card-icon">📢</div>
            <h3>PR Task Group</h3>
            <p>Promoting Solution Focused Therapy and EBTA through digital communications, website management, and social media outreach.</p>
            <div className="card-arrow">→</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TaskGroups;
